import { useState, useEffect } from "react";
import Tabs from "../tabs/Tabs";
import Map from "./Map";
import "./locations.scss";
import { withLanguage, withDictionary } from "../../assets/js/contexts";
import * as API from "../../helpers/api";
import config from "../../config";
import Loading from "react-loader-spinner";
import { useLang } from "../../helpers/language";

const Locations = () => {
  const [map, setMap] = useState("");
  const [marker, setMarker] = useState("");
  // eslint-disable-next-line
  const [locations, setLocations] = useState([]);
  const { lang } = useLang();
  const [isBusy, setBusy] = useState(true);
  const [data, setdata] = useState([]);
  // eslint-disable-next-line
  const [type_icon, settype_icon] = useState(null);
  const [types, settypes] = useState(null);
  const [rawtypes, setRawtypes] = useState(null);

  const updateE = (locations, types) => {
    let temproraryLocations = [];
    if (locations?.length > 0 && types?.length > 0) {
      locations.forEach((location) => {
        types.forEach((type) => {
          if (location.type_id === type._id) {
            let loc = Object.assign({}, location);
            loc.type_icon = type.uploads ? type.uploads[0]?.path : "banchka";
            settype_icon(type.uploads ? type.uploads[0]?.path : "banchka");
            temproraryLocations.push(loc);
          }
        });
      });
    }
    setLocations(temproraryLocations);
  };

  const updateT = () => {
    if (map) {
      let temproraryTypes = [];
      for (let ind = 0; ind < rawtypes?.length; ind++) {
        const type = rawtypes[ind];
        for (let index = 0; index < map?.locations?.length; index++) {
          const loc = map?.locations[index];
          if (loc?.type_id === type._id) {
            temproraryTypes.push(type);
            break;
          }
        }
      }
      settypes(temproraryTypes);
      updateE(map.locations, types);
    }
  }

  useEffect(() => {
    (async () => {
      let rowdata = await API.get(config.api.map);
      setdata(rowdata);
      let rawtypes = await API.get(config.api.mapType, {}, {}, true);
      const types = rawtypes;
      setRawtypes(types);
      if (rowdata && rowdata[0]) setMap(rowdata[0]);
      updateT()
      setBusy(false);
    })();
    // eslint-disable-next-line
  }, [isBusy]);

  useEffect(() => {
    updateT()
    // eslint-disable-next-line
  }, [map]);

  if (isBusy) return <Loading type="Oval" color="#FFBE03" className="loader" />;
  else
    return (
      <div id="locations">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <h2>{config.pages.home.locationInfo.title[lang]}</h2>
              {/* <p className="text-center">
                {config.pages.home.locationInfo.desc[lang]}
              </p> */}
            </div>
            <div className="col-md-8">
              <Tabs
                key={Date.now()}
                onChange={setMap}
                active={map}
                data={data}
                lang={lang}
              />
            </div>
            <div className="col-md-8">
              {map && (
                <Tabs
                  key={Date.now()}
                  onChange={setMarker}
                  active={marker}
                  data={types}
                  lang={lang}
                />
              )}
            </div>
          </div>
        </div>

        <div className="map-container">
          {map ? (
            <Map map={map} marker={marker._id} />
          ) : (
            <Loading type="Oval" color="#FFBE03" className="loader" />
          )}
        </div>
      </div>
    );
};

export default withLanguage(withDictionary(Locations));
